export default "__VITE_ASSET__Bob9mCgd__"